import BaseService from '@/ecm/common/BaseService.js';

class EmailSettingService {
  baseUrl = 'emailSetting';

  save = (settings) => BaseService.post({ url: `${this.baseUrl}`, data: settings });
  getAll = () => BaseService.get({ url: `${this.baseUrl}` });
}

export default new EmailSettingService();